import { useParameter, useDictionaryItem } from '../../../shared';
import { dictionaryService } from '../../../dataFlow';
import React from 'react';

export function useCommoditiesGroupName() {
  const [business] = [1]; //useParameter<number>("@business-units");
  const [commoditiesGroupParam = []] = useParameter<number[]>('@commodities_groups'); 
  const commoditiesGroupId = commoditiesGroupParam![0] && Number(commoditiesGroupParam![0]);
  const [, commoditiesGroupItemName] = useDictionaryItem(dictionaryService, 'slides-commodities-display', commoditiesGroupId, {
    business_unit: Number(business),
    slide: 7
  });
  const commoditiesGroupName = commoditiesGroupItemName ? commoditiesGroupItemName[9] : '';
  return commoditiesGroupName;
}